import React from 'react'
import PropTypes from 'prop-types'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import SyncedTransactionsProvider, { useSyncedTransactions } from './SyncedTransactionsProvider'
import SyncedTransactionsToolbar from './SyncedTransactionsToolbar'
import SyncedTransactionsGrid from './SyncedTransactionsGrid'
import SyncedTransactionsMetrics from './SyncedTransactionsMetrics'
import TransactionDetailModal from './TransactionDetailModal'
import TransactionDetailDrawer from './TransactionDetailDrawer'

function DetailViewSwitch () {
  const { config, selectedTransactionId, onDetailClose } = useSyncedTransactions()
  const open = selectedTransactionId != null
  const detailView = config.detailView

  if (detailView === 'drawer') {
    return (
      <TransactionDetailDrawer
        open={open}
        onClose={onDetailClose}
        transactionId={selectedTransactionId}
      />
    )
  }

  if (detailView && detailView !== 'disabled') {
    return (
      <TransactionDetailModal
        open={open}
        onClose={onDetailClose}
        transactionId={selectedTransactionId}
      />
    )
  }

  return null
}

function SyncedTransactionsRenderer ({ config }) {
  return (
    <FadeIn>
      <SyncedTransactionsProvider config={config}>
        <SyncedTransactionsToolbar />
        <SyncedTransactionsMetrics />
        <SyncedTransactionsGrid />
        <DetailViewSwitch />
      </SyncedTransactionsProvider>
    </FadeIn>
  )
}

SyncedTransactionsRenderer.propTypes = {
  config: PropTypes.object
}

export default SyncedTransactionsRenderer
